// Rutgers University-Camden's undergraduate majors. Read on 2026-10-01 from
// the official 2026-2027 Camden Undergraduate Catalog
// (camden-undergrad-26-27.catalogs.rutgers.edu): the Camden College of Arts
// and Sciences' Major Programs page (Bachelor of Arts and Bachelor of
// Science lists, with the catalog's B.A./B.S.), the School of Business-Camden
// Degree Programs page (six B.S. majors and the bachelor of arts in business
// administration, "B.B.A.", delivered online) and the School of
// Nursing-Camden Programs of Study page (the bachelor of science in nursing
// and its three tracks; the catalog gives no abbreviation, so the degree is
// null and the note names it). The catalog's subject codes (014, 080, ...)
// are dropped; the Art concentrations sit in a note. Left out: minors,
// concentrations, pre-professional tracks (premedicine, preengineering,
// prelaw, prepharmacy), University College-Camden (adult and part-time
// programs) and dual degrees. The KB's majors list was the starting point;
// the catalog wins.
const majors = {
    "slug": "rutgers-university-camden",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Rutgers-Camden's official 2026-2027 Undergraduate Catalog, grouped by the school that offers it, with the degree it leads to. Minors, certificates, graduate programs and dual-degree programs are left out.",
    "groups": [
        {
            "name": "Camden College of Arts and Sciences",
            "source": {
                "label": "Rutgers-Camden 2026-2027 Undergraduate Catalog, CCAS Major Programs",
                "url": "https://camden-undergrad-26-27.catalogs.rutgers.edu/schools/school-of-arts-and-sciences-camden/camden-college-of-arts-and-sciences/about/programs-of-study/major-programs"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Art",
                    "degree": "B.A.",
                    "note": "Concentrations in animation, arts education, art therapy, graphic design, intermedia and electronic arts, painting and drawing, photography, and sculpture."
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Childhood Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Computational and Integrative Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Criminal Justice",
                    "degree": "B.A."
                },
                {
                    "name": "Digital Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "French",
                    "degree": "B.A."
                },
                {
                    "name": "Gender Studies",
                    "degree": "B.A."
                },
                {
                    "name": "General Science",
                    "degree": "B.S."
                },
                {
                    "name": "German",
                    "degree": "B.A."
                },
                {
                    "name": "Global Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Health Sciences",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Individualized Major",
                    "degree": "B.A."
                },
                {
                    "name": "Individualized Major",
                    "degree": "B.S."
                },
                {
                    "name": "Liberal Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Religion",
                    "degree": "B.A."
                },
                {
                    "name": "Social Work",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Theater",
                    "degree": "B.A."
                },
                {
                    "name": "Urban Studies",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Rutgers School of Business-Camden",
            "source": {
                "label": "Rutgers-Camden 2026-2027 Undergraduate Catalog, School of Business Degree Programs",
                "url": "https://camden-undergrad-26-27.catalogs.rutgers.edu/schools/rutgers-school-of-business-camden/school-of-business-camden/degree-programs/degree-programs"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.S."
                },
                {
                    "name": "Business Administration",
                    "degree": "B.B.A.",
                    "note": "A bachelor of arts delivered online; an off-campus version with partner community colleges is for transfer students."
                },
                {
                    "name": "Entrepreneurship and Innovation",
                    "degree": "B.S."
                },
                {
                    "name": "Finance",
                    "degree": "B.S."
                },
                {
                    "name": "Human Resource Management",
                    "degree": "B.S."
                },
                {
                    "name": "Management",
                    "degree": "B.S."
                },
                {
                    "name": "Marketing",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Rutgers School of Nursing-Camden",
            "source": {
                "label": "Rutgers-Camden 2026-2027 Undergraduate Catalog, School of Nursing Programs of Study",
                "url": "https://camden-undergrad-26-27.catalogs.rutgers.edu/schools/school-of-nursing-camden/about/programs-faculty-and-general-information/programs-of-study"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": null,
                    "note": "The bachelor of science in nursing, as a traditional four-year track; an accelerated track (ABS) for college graduates and an RN-BS track for registered nurses are also offered."
                }
            ]
        }
    ]
};

export default majors;
